"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { normalizeSingleFilterFormData } from "@/helpers/request-helpers";
import { ICustomerSalesProductPayment } from "@/interfaces/customer-sales-product-payment.interfaces";
import customerSalesProductPaymentService from "@/services/customer-sales-product-payment-service";
import { IFilter } from "@/types/filter.types";
import {
  GetRequestProps,
  PaginatedResponse,
  RequestPagination,
  RequestsBaseReturn,
} from "@/types/requests.types";

export type Return = RequestsBaseReturn<PaginatedResponse<ICustomerSalesProductPayment> | null>;

export interface Props extends RequestPagination, GetRequestProps {
  filters: IFilter<ICustomerSalesProductPayment>[];
}

type GetAllSwrParams = [string, number, number, IFilter<ICustomerSalesProductPayment>[]];

const useGetCustomerSalesProductPayments = ({ pageNumber, pageSize, filters }: Props): Return => {
  const normalizedFilter = normalizeSingleFilterFormData(filters, "customerSalesProductId");

  const fetcher = useSWR<PaginatedResponse<ICustomerSalesProductPayment>, Error, GetAllSwrParams>(
    [SWR_KEYS.getCustomerSalesProductPayments, pageNumber, pageSize, normalizedFilter],
    ([, _pageNumber, _pageSize, _filters]) =>
      customerSalesProductPaymentService.filter(_filters, {
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }, "billingDate", "desc"),
    {
      revalidateOnFocus: false,
    }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetCustomerSalesProductPayments;
